<template>
  <form @submit.prevent="onSubmit" style="width: 100%;">
    <div class="columns">
      <div class="column">
        <field-input
          :value.sync="contact.name"
          name="name"
          required
          :label="`${$t('form.name')}:`"
          :vvas="$t('form.name')"
        />
      </div>
      <div class="column">
        <field-input
          :value.sync="contact.email"
          type="email"
          name="email"
          required
          :label="`${$t('form.email')}:`"
          :vvas="$t('form.email')"
        />
      </div>
      <div class="column">
        <field-input
          :value.sync="contact.phone"
          type="tel"
          name="phone"
          required
          :label="`${$t('form.phone_number')}:`"
          :vvas="$t('form.phone_number')"
        />
      </div>
    </div>
    <div class="field m-t-5">
      <div class="control is-clearfix">
        <button
          class="button is-primary is-pulled-right"
          :class="{ 'is-loading': formLoading }"
        >{{ $t("form.submit") }}</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      formLoading: false
    }
  },

  computed: {
    active() {
      return this.$store.state.users.active;
    },

    contact() {
      return this.active.contacts.find(e => e.id == this.$route.params.contact);
    }
  },

  methods: {
    populateForm() {
      this.name = this.contact.name;
      this.email = this.contact.email;
      this.phone = this.contact.phone;
    },

    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      const request = {
        name: this.contact.name,
        email: this.contact.email,
        phone: this.contact.phone
      };

      try {
        const { data } = await this.$api.updateContact(this.contact.id, request);

        this.$toast.success(data.message);

        this.$router.push(
          this.localePath({ name: 'office-users-id-contacts' })
        );
        
        this.$store.commit("users/UPDATE_CONTACT", {contact: this.contact.id, request, user: this.$route.params.id });

      } catch (e) {
        console.log(e);
        this.handleFormError(e.response.data);
      }

      this.formLoading = false;
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/users/_id/contacts/_contact/edit.vue